import script from "./VerifyCode.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyCode.vue?vue&type=script&setup=true&lang=js"

import "./VerifyCode.vue?vue&type=style&index=0&id=8306cf74&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8306cf74"]])

export default __exports__